module.exports = __webpack_public_path__ + "static/devconnector-8f35d3822d27855b9c8bfc41b33fb71a.jpg";